// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { LaneLine, ILaneLine } from "./LaneLine.gen";

export interface IGenerateLaneLinesResult {
	enough: boolean;

	availableHours: number;

	trackCount: number;

	laneLines: ILaneLine[] | undefined;

	message: string | undefined;

	$type?: string | undefined;
}
export class GenerateLaneLinesResult {
	constructor(data?: IGenerateLaneLinesResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.laneLines = data.laneLines ? data.laneLines.map((l: any) => new LaneLine(l)) : [];
	}

	enough: boolean = false;

	availableHours: number = 0;

	trackCount: number = 0;

	laneLines: LaneLine[] | undefined = [];

	message: string | undefined;

	static $type: string = "CoreApi.Models.Layout.GenerateLaneLinesResult, ";
	$type?: string | undefined = GenerateLaneLinesResult.$type;
}

